import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import shakibUser from "../../.././../../Assets/Images/cricket.jpg";
import starShowcase from "../../.././../../Assets/Images/starShowcase.png";
import "./StarShowcaseSearch.css";

const StarShowcaseSearch = (props) => {

  const { imageCdnUrl } = useContext(serverInfo);


  return (
    <div>
      <div className="searchUserFirst">
        <h6 className="mx-3 py-2 text-light">Souvenir</h6>
        <div className="underLineBlackSearch"></div>

        <div className="my-2 py-3">
          <div className="row my-1">
            {props.searchSuggSouvenir?.map((souvenir) => (
              <div className="col-md-6">
                <div className="d-flex justify-content-center align-items-center bgDarkStar mx-3 p-2">
                  <img src={starShowcase} width="60" height="60" alt="" />
                  <img
                    src={imageCdnUrl + souvenir?.banner}
                    className="peoplePhotoAvatar img-fluid"
                    alt=""
                  />
                  <div className="text-light d-flex flex-column justify-content-center mx-2 pt-2">
                    <h4>{souvenir?.title}</h4>
                    {/* <p>@superstar</p> */}
                    <Link to={`/starprofile/${souvenir?.star_id}/souvenir`}>
                      Apply Now
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StarShowcaseSearch;
